const getSentryEnvByBrowserUrl = (): string => {
  const { hostname } = window.location;
  const matchResult = hostname.match(/^(.*)\..*\..*$/i);

  if (!matchResult || !matchResult[1]) {
    return 'unmapped';
  }
  return matchResult[1];
};

const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN || '';

export const config = {
  ENV: process.env.REACT_APP_ENV,
  MAPBOX_ACCESS_TOKEN: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
  SERVER_URL: process.env.REACT_APP_SERVER_URL,
  COVERAGE_API_BASE_URL: process.env.REACT_APP_COVERAGE_API_BASE_URL,
  MOBILE_REDIRECT: process.env.REACT_APP_MOBILE_REDIRECT,
  AUTH_SERVER_URL: process.env.REACT_APP_AUTH_SERVER_URL,
  LOGIN_URL: process.env.REACT_APP_LOGIN_URL,
  OKTA_DOMAIN: process.env.REACT_APP_OKTA_DOMAIN,
  OKTA_AUTH_SERVER_ID: process.env.REACT_APP_OKTA_AUTH_SERVER_ID,
  OKTA_CLIENT_ID: process.env.REACT_APP_OKTA_CLIENT_ID,
  COUNTRIES_SEARCH_LIMIT: process.env.REACT_APP_COUNTRIES_SEARCH_LIMIT,
  DEFAULT_INTEREST_AREA: JSON.parse(process.env.REACT_APP_DEFAULT_INTEREST_AREA),
  COOKIE_DOMAIN,
  IS_STAGING: COOKIE_DOMAIN.toLocaleLowerCase().includes('staging'),
  MAP_STYLE: process.env.REACT_APP_MAP_STYLE,
  MAP_HIGH_CONTRAST_STYLE: process.env.REACT_APP_MAP_HIGH_CONTRAST_STYLE,
  SATELLITE_STYLE: process.env.REACT_APP_SATELLITE_STYLE,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  SENTRY_ENV: process.env.REACT_APP_DEVELOPMENT_MODE ? 'development' : getSentryEnvByBrowserUrl(),
};
